export default "__VITE_ASSET__BwW9ncjg__"